import { useEffect, useState } from 'react'
import { isMobileViewport } from '@App/libs/utils/geral'

export const useIsMobile = (breakpoint?: number) => {
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const checkIsMobile = () => setIsMobile(isMobileViewport(breakpoint))

        checkIsMobile()
        window.addEventListener('resize', checkIsMobile)

        return () => window.removeEventListener('resize', checkIsMobile)
    }, [breakpoint])

    return isMobile
}
